import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { getApiData, getApiRecord } from 'services/StockHoldingsService'

export const getData = createAsyncThunk('stockHoldings/data/getData', async data => {
    const response = await getApiData(data)
    return response.data
})

export const getRecord = createAsyncThunk('stockHoldings/data/getRecord', async id => {
    const response = await getApiRecord(id)
    return response.data
})

const recordData = {
    site: '',
    client: '',
    shipment: '',
    customer: '',
    order_type: '',
    reference_1: '',
    reference_2: '',
    status: '',
    created_date: '',
    closed_date: '',
    carrier: '',
    carrier_service: '',
    tracking: '',
}

const initialTableData = {
    total: 0,
    pageIndex: 1,
    pageSize: 100,
    query: '',
    selectedTab: '',
    sort: [{ column: '', dir: '' }],
}

const dataSlice = createSlice({
    name: 'stockHoldings/data',
    initialState: {
        loading: false,
        record: recordData,
        data: [],
        tableData: initialTableData,
    },
    reducers: {
        setData: (state, { payload }) => {
            state.data = payload
        },
        setRecord: (state, { payload }) => {
            state.record = payload
        },
        setTableData: (state, { payload }) => {
            state.tableData = payload
        },
    },
    extraReducers: builder => {
        builder
            .addCase(getData.pending, state => {
                state.loading = true
                state.tableData.total = 0
            })
            .addCase(getData.fulfilled, (state, { payload }) => {
                state.loading = false
                state.data = payload?.data
                state.tableData.total = payload?.count
            })
            .addCase(getData.rejected, state => {
                state.loading = false
                state.data = []
            })
            .addCase(getRecord.fulfilled, (state, { payload }) => {
                state.loading = false
                state.record = payload
            })
            .addCase(getRecord.pending, state => {
                state.loading = true
                state.record = null
            })
            .addCase(getRecord.rejected, state => {
                state.loading = false
                state.record = null
            })
    },
})

export const { setData, setRecord, setTableData } = dataSlice.actions

export default dataSlice.reducer
